import script from "./FaxFormSelectionComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaxFormSelectionComponent.vue?vue&type=script&setup=true&lang=ts"

import "./FaxFormSelectionComponent.vue?vue&type=style&index=0&id=21cfc5ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21cfc5ec"]])

export default __exports__